import { FETCH_MERKLISTEN_PRODUCTS_REQUEST, FETCH_MERKLISTEN_PRODUCTS_SUCCESS, FETCH_MERKLISTEN_PRODUCTS_FAILURE, ADD_TO_MERKLISTE_SUCCESS, ADD_TO_MERKLISTE_FAILURE, REMOVE_FROM_MERKLISTE_FAILURE, REMOVE_FROM_MERKLISTE_SUCCESS, ADD_TO_MERKLISTE_REQUEST, REMOVE_FROM_MERKLISTE_REQUEST, UPDATE_MERKLISTE_FOR_USER } from '../actionTypes';
import { FAILURE, FETCHING, PENDING, SUCCESS } from '../fetchStatus';

const initialState = {
    merkliste: {
        data: [],
    },
    merklistenProducts: {},
    unavailableProducts: [],
};

export default function merkliste(state = initialState, action) {
    switch (action.type) {
        case ADD_TO_MERKLISTE_SUCCESS:
            let filteredProductsToAdd = [];
            if (state.merklistenProducts.data) {
                const newProduct = action.payload.product;
                filteredProductsToAdd = state.merklistenProducts.data.filter(existingProduct => {
                    if (existingProduct.selectedVariantId && newProduct.selectedVariantId) {
                        return existingProduct.selectedVariantId !== newProduct.selectedVariantId;
                    }
                    if (existingProduct.neutralKey && newProduct.neutralKey) {
                        return existingProduct.neutralKey !== newProduct.neutralKey;
                    }
                    
                    if (existingProduct._id && newProduct._id) {
                        return existingProduct._id !== newProduct._id;
                    }
                    return true;
                });
            }

            return {
                ...state,
                merkliste: {
                    status: SUCCESS,
                    data: [...(state?.merkliste?.data ?? []), { ...action.payload.entry }],
                },
                merklistenProducts: {
                    status: SUCCESS,
                    data: [...filteredProductsToAdd, { ...action.payload.product }]
                },
            };
        case REMOVE_FROM_MERKLISTE_SUCCESS:

            const removedSelectedVariant = action.payload.entry?.selectedVariant;
            const removedProductId = action.payload.entry?.productId;

            const filteredProductsToRemove = (state.merklistenProducts.data || []).filter(product => {
                const isSelectedVariantMatch =
                    removedSelectedVariant &&
                    product.selectedVariantId &&
                    String(product.selectedVariantId) === String(removedSelectedVariant);

                const isProductIdMatch =
                    removedProductId &&
                    (
                        (product.neutralKey && String(product.neutralKey) === String(removedProductId)) ||
                        (product._id && String(product._id) === String(removedProductId)) ||
                        (product.id && String(product.id) === String(removedProductId))
                    );

                return !(isSelectedVariantMatch || isProductIdMatch);
            });

            return {
                ...state,
                merkliste: {
                    status: SUCCESS,
                    data: state.merkliste.data.filter(entry =>
                        !(
                            String(entry.standort) === String(action.payload.entry.standort) &&
                            String(entry.selectedVariant) === String(action.payload.entry.selectedVariant)
                        )
                    )
                },
                merklistenProducts: {
                    status: SUCCESS,
                    data: filteredProductsToRemove
                }
            }
        case FETCH_MERKLISTEN_PRODUCTS_SUCCESS:
            return {
                ...state,
                merklistenProducts: {
                    status: SUCCESS,
                    data: action.payload.merklistenProducts,
                },
                unavailableProducts: action.payload.unavailableProducts || [],
            };
        case FETCH_MERKLISTEN_PRODUCTS_FAILURE:
            return {
                ...state,
                merklistenProducts: {
                    status: FAILURE,
                    error: action.payload.error,
                }
            };
        case ADD_TO_MERKLISTE_REQUEST:
        case REMOVE_FROM_MERKLISTE_REQUEST:
            return {
                ...state,
                merkliste: {
                    status: FETCHING,
                    data: state.merkliste?.data ?? [],
                }
            };
        case ADD_TO_MERKLISTE_FAILURE:
        case REMOVE_FROM_MERKLISTE_FAILURE:
            return {
                ...state,
                merkliste: {
                    status: FAILURE,
                    error: action.payload.error,
                    data: state.merkliste?.data ?? [],
                }
            };
        case UPDATE_MERKLISTE_FOR_USER:
            return {
                ...state,
                merkliste: {
                    status: SUCCESS,
                    data: action.payload.merkliste
                },
            }
        case FETCH_MERKLISTEN_PRODUCTS_REQUEST:
            return {
                ...state,
                merklistenProducts: {
                    status: FETCHING,
                    data: state.merklistenProducts?.data || [],
                }
            }
        default:
            return state;
    }
}